import Home from "../screens/users/Home";
import About from "../screens/users/About";
import Contact from "../screens/users/Contact";
import Portfolio from "../screens/users/Portfolio";
import ServiceDetail from "../components/User/Service/Servicedetail";

export const userRoutes = [
  {
    path: "/",
    component: <Home />,
  },
  {
    path: "/about",
    component: <About />,
  },
  {
    path: "/contact",
    component: <Contact />,
  },
  {
    path: "/portfolio",
    component: <Portfolio />,
  },
  {
    path: "/services/:slug",
    component: <ServiceDetail />,
  },
];
